//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class ChatService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[Chat.Delete]
	async delete(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/messenger/chat/delete', params || { });
	};

	//GeneratorFlag:[Chat.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/messenger/chat/detail', {'params':params});
	};

	//GeneratorFlag:[Chat.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/messenger/chat/list', {'params':params});
	};

	//GeneratorFlag:[Chat.Pin]
	async pin(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/messenger/chat/pin', params || { });
	};

	//GeneratorFlag:[Chat.Seen]
	async seen(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/messenger/chat/seen', params || { });
	};

	//GeneratorFlag:[Chat.Send]
	async send(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/messenger/chat/send', params || { });
	};

	//GeneratorFlag:[Chat.Notification]
	async notification(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/messenger/chat/notification', {'params':params});
	};

//GeneratorFlag:[NewAction]
}